import { download } from './download'

export function getSvgDataUriFromOuterHTML(el) {
    return `data:image/svg+xml,${encodeURIComponent(el.outerHTML)}`
}

export async function getPng(contentUrl, width, height) {
    return new Promise(resolve => {
        const canvas = document.createElement('canvas')
        canvas.height = height
        canvas.width = width
        canvas.style.height = `${height}px`
        canvas.style.width = `${width}px`

        const ctx = canvas.getContext('2d')

        const image = new Image()
        image.onload = function () {
            ctx.drawImage(image, 0, 0, width, height)
            resolve(canvas.toDataURL())
        }
        image.src = contentUrl
    })
}

export async function getPngFromOuterHTML(el, minimumDimension) {
    const contentUrl = getSvgDataUriFromOuterHTML(el)
    let height = el.clientHeight
    let width = el.clientWidth

    const min = Math.min(height, width)

    if (min !== minimumDimension) {
        if (min === height) {
            width = width * (minimumDimension / height)
            height = minimumDimension
        } else {
            height = height * (minimumDimension / width)
            width = minimumDimension
        }
    }

    return await getPng(contentUrl, width, height)
}

export function downloadSvg(el, filename) {
    download(getSvgDataUriFromOuterHTML(el), filename)
}

export async function downloadPng(el, filename, width = null, height = null) {
    const content = getSvgDataUriFromOuterHTML(el)

    if (width === null && height === null) {
        height = el.clientHeight
        width = el.clientWidth
    } else if (width === null) {
        height ??= el.clientHeight
        width = (height / el.clientHeight) * el.clientWidth
    } else if (height === null) {
        width ??= el.clientWidth
        height = (width / el.clientWidth) * el.clientHeight
    }

    download(await getPng(content, width, height), filename)
}
